import { Component, OnInit, Inject, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { DialogData } from 'app/core/interfaces/dialog';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { LocationAPIResponse } from 'app/core/interfaces/location';
import { addressI } from 'app/core/interfaces/adress';
import { HoursOfOperationAPIResponse } from 'app/core/interfaces/datatypes-fhir';

@Component({
  selector: 'page-organization-bond-details',
  templateUrl: './organization-bond-details.component.html',
  styleUrls: ['./organization-bond-details.component.scss'],
})
export class PractitionerOrganizationBondDetailsComponent extends BaseComponent implements OnInit {
  public location: LocationAPIResponse = <LocationAPIResponse>{};
  public address: addressI = <addressI>{};
  public latLong: [any, any] = [0, 0];
  public hours?: HoursOfOperationAPIResponse[] = [];

  constructor(public dialogRef: MatDialogRef<MaterialDialog>, @Inject(MAT_DIALOG_DATA) public data: DialogData, private injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.location = this.data.param.location;
    this.address = this.formatAddress(this.location.address[0]) ?? [];
    this.latLong = [this.location.position.latitude, this.location.position.longitude];
    this.hours = this.location.hoursOfOperation;
  }

  formatAddress(address: any) {
    const extraInfos = address?.line ?? [];

    return {
      cep: address.postalCode,
      city: address.city,
      country: address.country,
      state: address.state,
      street: extraInfos[0] ?? '',
      number: extraInfos[1] ?? '',
      complement: extraInfos[2] ?? '',
    };
  }

  formatPhone(value: string): string {
  if (!value) return '';
  let digits = String(value).replace(/\D/g, '');
  if (digits.length > 11 && digits.startsWith('55')) digits = digits.slice(2);
  if (digits.length === 11) return digits.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  if (digits.length === 10) return digits.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  return value;
}

  daysOfWeekMap: { [key: string]: number } = {
    mon: 1,
    tue: 2,
    wed: 3,
    thu: 4,
    fri: 5,
    sat: 6,
    sun: 0,
  };

  daysOfWeekNames: string[] = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];

  getDayNames(daysOfWeek: string[]): string {
    const dayIndex = this.daysOfWeekMap[daysOfWeek[0]];
    return this.daysOfWeekNames[dayIndex];
  }
}
